import React from 'react';
import { Badge } from 'shared-portal-components-v2';

import type { ExternalUserStatus } from '@/types/external-users.types';

const STATUS_BADGE_VARIANT: Record<ExternalUserStatus, 'primary' | 'secondary' | 'outline'> = {
  Active: 'primary',
  Unregistered: 'secondary',
  Inactive: 'outline',
};

interface ExternalUserStatusBadgeProps {
  status: ExternalUserStatus;
}

function ExternalUserStatusBadge({ status }: ExternalUserStatusBadgeProps): React.ReactElement {
  return <Badge variant={STATUS_BADGE_VARIANT[status]}>{status}</Badge>;
}

export default ExternalUserStatusBadge;
